var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eh-participant-component"},[_c('fp-prescription-list',{attrs:{"participant":_vm.userPatientData,"sortBy":"PrescriptionId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }